$('.tile-product .product-details-link, .tile-product .pt__visual a').on('click contextmenu', $.debounce(function (event) {
    UAEvents.click(event.target, 'product', 'documentOpen', '.products-search--grid .tile-product', '.tile-product', true);
}, 300));

$('.tile-product .pt__content--actions .action__favorite').click($.debounce(function (event) {
    UAEvents.click(event.target, 'product', 'documentOpen', '.products-search--grid .tile-product', '.tile-product', true);
}, 300));

$('.tile-product .pt__content--actions .cart-plus').click($.debounce(function (event) {
    UAEvents.click(event.target, 'product', 'documentOpen', '.products-search--grid .tile-product', '.tile-product', true);
}, 300));

$('.tile-product .pt__content--actions .plus-addToCart').click($.debounce(function (event) {
    UAEvents.click(event.target, 'product', 'documentOpen', '.products-search--grid .tile-product', '.tile-product', true);
}, 300));

$('.tile-product .pt__content--actions .minus-addToCart').click($.debounce(function (event) {
    UAEvents.click(event.target, 'product', 'documentOpen', '.products-search--grid .tile-product', '.tile-product', true);
}, 300));